import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import { T } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

dayjs.extend(relativeTime)

const LIVE_METRIC_TRANSLATION = {
  finished: TOLGEE_GLOBALS.streamDate,
  inProgress: TOLGEE_GLOBALS.uploadDate,
  scheduled: TOLGEE_GLOBALS.scheduled,
}
const LIVE_DATE_FORMATTING = {
  finished: {
    dateKey: 'startTime',
    formatDate: date => dayjs(date).format('DD/MM/YYYY'),
  },
  inProgress: {
    dateKey: '',
    formatDate: () => <T keyName={TOLGEE_GLOBALS.liveNow.key}>{TOLGEE_GLOBALS.liveNow.defaultValue}</T>,
  },
  scheduled: {
    dateKey: 'scheduledTime',
    formatDate: date => dayjs(date).format('DD/MM/YYYY, HH:mm'),
  },
}

function LivePostDate({ live }) {
  if (!live) {
    return null
  }

  const metricTranslation = LIVE_METRIC_TRANSLATION?.[live?.state]
  const dateFormatting = LIVE_DATE_FORMATTING?.[live?.state]

  return (
    <div className="VideoCardList-LivePostDate">
      {dateFormatting.formatDate(live?.[dateFormatting?.dateKey])}

      <div className="VideoCardList-metric-label">
        <T keyName={metricTranslation.key}>{metricTranslation.defaultValue}</T>
      </div>
    </div>
  )
}

export default LivePostDate
